import ContentDivider from './ContentDivider';

export default ContentDivider;
